const PAYMENT_CHANNEL_DEFS = [
  { key: 'wechat', code: 'wx_native', label: '微信支付', missingMsg: '未获取到微信二维码，请检查支付配置' },
  { key: 'alipay', code: 'alipay_pc', label: '支付宝支付', missingMsg: '未获取到支付宝二维码，请检查支付配置' },
];

const collectMultiChannelPayments = ({ settled, resolveErrorMessage, onSuccess }) => {
  const payments = {};
  const orderNos = [];
  const channelErrors = [];

  settled.forEach((result, idx) => {
    const channel = PAYMENT_CHANNEL_DEFS[idx];
    if (result.status !== 'fulfilled') {
      channelErrors.push(`${channel.label}：${result.reason?.message || String(result.reason || '创建失败')}`);
      return;
    }
    const resp = result.value || {};
    if (resp?.status !== 'success') {
      channelErrors.push(`${channel.label}：${resolveErrorMessage(resp?.error_message, '创建支付失败')}`);
      return;
    }
    const qrValue = String(resp?.display_content || resp?.code_url || '').trim();
    if (!qrValue) {
      channelErrors.push(`${channel.label}：${channel.missingMsg}`);
      return;
    }
    const outTradeNo = String(resp?.out_trade_no || '').trim();
    if (outTradeNo) orderNos.push(outTradeNo);
    payments[channel.key] = {
      out_trade_no: outTradeNo,
      channel_code: channel.code,
      display_mode: 'qr_code',
      display_content: qrValue,
      label: channel.label,
    };
    if (typeof onSuccess === 'function') {
      onSuccess(resp);
    }
  });

  return { payments, orderNos, channelErrors };
};

const ensureAtLeastOneChannel = ({ payments, channelErrors }) => {
  if (payments.wechat || payments.alipay) return;
  throw new Error(channelErrors.join('；') || '创建支付失败');
};

export const createSubscriptionCheckoutFlow = async ({
  plan,
  campaignCode,
  createCheckout,
  resolveErrorMessage,
}) => {
  const currentPlanId = String(plan?.plan_id || '').trim();
  if (!currentPlanId) return null;

  let resolvedPlan = plan;
  let resolvedCampaign = null;
  const settled = await Promise.allSettled(
    PAYMENT_CHANNEL_DEFS.map((channel) => createCheckout({
      plan_id: currentPlanId,
      channel_code: channel.code,
      campaign_code: String(campaignCode || '').trim() || undefined,
    })),
  );

  const { payments, orderNos, channelErrors } = collectMultiChannelPayments({
    settled,
    resolveErrorMessage,
    onSuccess: (resp) => {
      if (resp?.plan) resolvedPlan = resp.plan;
      if (resp?.campaign) resolvedCampaign = resp.campaign;
    },
  });

  ensureAtLeastOneChannel({ payments, channelErrors });

  return {
    checkout: {
      order_type: 'subscription',
      channel_code: 'multi_qr',
      display_mode: 'multi_qr',
      plan: resolvedPlan || null,
      campaign: resolvedCampaign,
      payments,
      order_nos: orderNos,
      out_trade_no: orderNos[0] || '',
    },
    orderNos,
    channelErrors,
  };
};

export const createCreditPackCheckoutFlow = async ({
  pack,
  createCreditPackCheckout,
  resolveErrorMessage,
}) => {
  const currentPackId = String(pack?.pack_id || '').trim();
  if (!currentPackId) return null;

  let resolvedPack = pack;
  const settled = await Promise.allSettled(
    PAYMENT_CHANNEL_DEFS.map((channel) => createCreditPackCheckout({
      pack_id: currentPackId,
      channel_code: channel.code,
    })),
  );

  const { payments, orderNos, channelErrors } = collectMultiChannelPayments({
    settled,
    resolveErrorMessage,
    onSuccess: (resp) => {
      if (resp?.credit_pack) resolvedPack = resp.credit_pack;
    },
  });

  ensureAtLeastOneChannel({ payments, channelErrors });

  return {
    checkout: {
      order_type: 'credit_pack',
      channel_code: 'multi_qr',
      display_mode: 'multi_qr',
      credit_pack: resolvedPack || null,
      payments,
      order_nos: orderNos,
      out_trade_no: orderNos[0] || '',
    },
    orderNos,
    channelErrors,
  };
};
